<template >
  <section class="liveEarth">
    <h1>liveEarth Component</h1>
    <iframe
      id="liveEarth iFrame"
      title="liveEarth iFrame"
      style="width:100%;height:90%;"
      src="https://www.openstreetmap.org/export/embed.html?bbox=-0.004017949104309083%2C51.47612752641776%2C0.00030577182769775396%2C51.478569861898606&layer=mapnik"
    ></iframe>
  </section>
</template>

<script>
export default {
  name: "liveEarth",
  props: [],
  mounted() {},
  data() {
    return {};
  },
  methods: {},
  computed: {}
};
</script>

<style scoped lang="scss">
@import "../styles/_vars.scss";
.liveEarth {
  height: 100vh;
  width: 100vw;
  background: linear-gradient(270deg, #7f35b2, #0191da, #78be20);
  background-size: 1000% 1000%;
  color: $color-white;
  animation: gradientRippler 5s ease infinite alternate;
  iframe {
    width: 100%;
  }
}
</style>